import { Flex } from "antd";
import React, { useEffect } from "react";

const NEW_WEBAPP_BASEURL =
  "https://registration-frontend-860587874.catalystserverless.com/app";

const RedirectionPage = () => {
  useEffect(() => {
    if (window.location.hash) {
      window.location.href = `${NEW_WEBAPP_BASEURL}/${window.location.hash}`;
    }
  }, []);

  return (
    <Flex align="center" justify="center" style={{ minHeight: "40vh" }}>
      <div className="loader_layout"></div>
    </Flex>
  );
};

export default RedirectionPage;
